export const COLUMNS = {
    '1/4': '25%',
    '2/4': '50%',
    '3/4': '75%',
    '4/4': '100%',
    '1/6': '16.66666667%',
    '2/6': '33.33333333%',
    '3/6': '50%',
    '4/6': '66.66666667%',
    '5/6': '83.33333333%',
    '6/6': '100%',
    '1/12': '8.33333333%',
    '2/12': '16.66666666%',
    '3/12': '25%',
    '4/12': '33.33333333%',
    '5/12': '41.66666667%',
    '6/12': '50%',
    '7/12': '58.33333333%',
    '8/12': '66.66666667%',
    '9/12': '75%',
    '10/12': '83.33333333%',
    '11/12': '91.66666667%',
    '12/12': '100%',
};
export const getSyncedMaxQuery = (breakpoint) => {
    const windowWidth = breakpoint.replace('px', '');
    return `${Number(windowWidth) - 1}px`;
};
